module.exports = __webpack_public_path__ + "img/loveperson-bg.4c623a6f.png";